"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var modal_component_1 = require("./modal.component");
var ModalHeaderComponent = (function () {
    function ModalHeaderComponent(modal) {
        this.modal = modal;
        this.showClose = false;
    }
    return ModalHeaderComponent;
}());
__decorate([
    core_1.Input('show-close'),
    __metadata("design:type", Boolean)
], ModalHeaderComponent.prototype, "showClose", void 0);
ModalHeaderComponent = __decorate([
    core_1.Component({
        selector: 'modal-header',
        template: "\n      <div class=\"modal-header\"><button class=\"close\" *ngIf=\"showClose\" type=\"button\" data-dismiss=\"modal\" aria-label=\"Close\" (click)=\"modal.dismiss()\"><span aria-hidden=\"true\">\u00D7</span></button><ng-content></ng-content></div>\n    ",
    }),
    __metadata("design:paramtypes", [modal_component_1.ModalComponent])
], ModalHeaderComponent);
exports.ModalHeaderComponent = ModalHeaderComponent;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-material-components/user-interface/modal/modal-header.component.js
// module id = 127
// module chunks = 0